// @flow

import * as React from 'react'

let result = () => (InnerComp: React.ComponentType<*>) => () => <InnerComp />

if (process.env.NODE_ENV === 'development') {
  let VConsole = require('vconsole')
  result = function () {
    return function (InnerComp: React.ComponentType<*>) {
      class LoadTime extends React.Component<*, *> {
        time: number = 0;
        timer: number = 0;
        vConsole: any;
        handleClick = () => {
          if (!VConsole || this.vConsole) return
          const now = Date.now()
          const isTimeout = now - this.timer > 500
          this.timer = now
          if (isTimeout) {
            this.time = 0
            return
          }
          if (++this.time === 5) {
            this.time = 0
            this.vConsole = new VConsole()
          }
        };

        componentWillMount () {
          window.addEventListener('click', this.handleClick)
        }

        componentWillUnmount () {
          window.removeEventListener('click', this.handleClick)
        }

        render () {
          return <InnerComp />
        }
      }
      return LoadTime
    }
  }
}

export default result



// WEBPACK FOOTER //
// ./src/frame/hoc/vConsole.js